export type SellerMobilePlatform = "android" | "ios";

type SellerMobilePlatformInput = {
  userAgent: string;
  maxTouchPoints?: number;
};

function isIosDevice(userAgent: string, maxTouchPoints: number): boolean {
  return (
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)
  );
}

export function detectSellerMobilePlatform({
  userAgent,
  maxTouchPoints = 0,
}: SellerMobilePlatformInput): SellerMobilePlatform | null {
  if (/Android/i.test(userAgent)) {
    return "android";
  }

  if (isIosDevice(userAgent, maxTouchPoints)) {
    return "ios";
  }

  return null;
}
